var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignature = function SvgSignature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7v14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4.586l-3.293 3.293A1 1 0 0 1 12 20H5a1 1 0 1 1 0-2h3v-2a1 1 0 0 1 .293-.707L16 7.586V3a1 1 0 0 0-1-1H7v4a1 1 0 0 1-1 1H2zm3-2V2.126A4.007 4.007 0 0 0 2.126 5H5zm13 16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6a6 6 0 0 1 6-6h9a3 3 0 0 1 3 3v3c.256 0 .512.098.707.293l3 3a1 1 0 0 1 0 1.414L18 14.414V21zm-6.414-3 8-8L18 8.414l-8 8V18h1.586z",
    fill: "#fff"
  })));
};
export default SvgSignature;